import { render } from "./StartGame.vue?vue&type=template&id=48bf7bfe&scoped=true"
import script from "./StartGame.vue?vue&type=script&lang=js"
export * from "./StartGame.vue?vue&type=script&lang=js"

import "./StartGame.vue?vue&type=style&index=0&id=48bf7bfe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-48bf7bfe"

export default script